import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from 'components/BasicButton';
import BasicButtonGroup from 'components/BasicButtonGroup';
import Dialog from 'scenes/Dialog';
import Popup from 'components/Popup';
import UxHelpers from 'helpers/ux-helpers.js';

const NoAddReviewRight = props => {
  const { show, dismiss, type } = props;

  const dismissHandler = () => {
    dismiss();
    UxHelpers.overflowLock('unlock');
  };

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={dismissHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={'ОК'}
      />
    </BasicButtonGroup>
  );

  const body = (
    <Dialog>
      <div style={{ textAlign: 'center' }}>
        {
          {
            interview: 'You have already submitted reviews for all firms',
            employee:
              'You have already submitted reviews for all your employers',
            company: 'You have already submitted reviews for all firms',
          }[type]
        }
      </div>
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{
          dismiss,
        }}
        buttonsRender={buttons}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(NoAddReviewRight));
